import { Http, Response, Request } from '@angular/http';
import { Injectable } from '@angular/core';
import { DataService } from './api.data.service';
import { Enquiry } from './model';


@Injectable()
export class EnquiryService {

    private _ContactUsAPI: string = '/api/enquiry';

    constructor(public _EnquiryService: DataService) { }

    contactus(enquiry: Enquiry) {
        this._EnquiryService.set(this._ContactUsAPI);
        //return this._EnquiryService.post(JSON.stringify(enquiry));
        return this._EnquiryService.post(enquiry);
    }

}


/** WEBPACK FOOTER **
 ** ./src/app/api.service.ts
 **/